import { render, staticRenderFns } from "./RecruitmentBase.vue?vue&type=template&id=0b15f7b6&scoped=true&"
import script from "./RecruitmentBase.vue?vue&type=script&lang=js&"
export * from "./RecruitmentBase.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentBase.vue?vue&type=style&index=0&id=0b15f7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15f7b6",
  null
  
)

export default component.exports